<template>
  <div class="scene" style="">
    <loading
      :width="100"
      loader="dots"
      color="#ffacb7"
      :active="actionLoading"
      background-color="transparent"
    />
    <div class="scene-box">
      <div
        class="scenes-title"
        style="
          display: flex;
          justify-content: space-between;
          line-height: 26px;
          padding: 5px 10px;
          font-size: 14px;
        "
      >
        <div class="scenes-title-left">场景元素</div>
        <div class="scenes-title-more">
          <span style="display: none">帮助</span>
          <span style="margin: 0 10; display: none" @click="visibleBase = true"
            >...</span
          >
          <!-- <span @click="cancel" style=""
            ><i class="iconfont icon-guanbi"></i
          ></span> -->
          <span @click="selector_scene_assembly.top = 0">
            <i class="iconfont icon-out-column"></i>
            增加组件
          </span>
        </div>
      </div>
      <div class="scene-items">
        <!-- 拖拽排序组件(之前是拖动.move绑定的图片,更改为.item拖动整个div) -->
        <draggable
          v-model="t9video.videoobj.scenes[0].res"
          handle=".item"
          chosen-class="chosen"
          ghost-class="ghost"
          @end="dragEnd"
        >
          <transition-group>
            <div
              :class="{
                active: i == res_index,
              }"
              class="item scene-item"
              v-for="(ires, i) in t9video.videoobj.scenes[0].res"
              :key="i + 'res'"
              @click="changeTab(ires, ires.restype, i)"
            >
              <span
                v-if="ires.resimg"
                class="img move"
                :style="{
                  backgroundImage: 'url(' + ires.resimg + ')',
                  backgroundSize: 'cover',
                }"
              ></span>
              <span
                class="move img iconfont icon-shangyong"
                v-if="ires.restype == 3"
              ></span>
              <span
                class="move img iconfont icon-zimuku"
                v-if="ires.restype == 'subtitle'"
              ></span>
              <span
                class="move img iconfont icon-wodedaoju"
                v-if="ires.restype == '3d'"
              ></span>
              {{ ires.resname }}
              <div
                style="position: absolute; right: 5px"
                v-if="ires.restype != 1"
              >
                <button @click="deleteres(ires)">移除</button>
              </div>
              <div
                style="position: absolute; right: 5px"
                v-if="ires.restype == 1"
              >
                <!-- <button @click="changeRole(ires.resid)">切换</button> -->
                <button @click="goSetRole()">切换</button>
              </div>
            </div>
          </transition-group>
        </draggable>

        <div
          class="scene-item"
          :class="{
            active: res_index == null || res_index == undefined,
          }"
          @click="changeTab('all', null, 0)"
        >
          <span class="img iconfont icon-yuanqu"></span>
          背景管理
        </div>

        <center
          style="color: rgb(189 189 189); margin: 10px auto; font-size: 14px"
        >
          <i class="iconfont icon-gantanhao"></i
          >提示<br />拖拽图标可调整上下层遮挡关系（背景除外）
        </center>
      </div>

      <div
        class="scene-addmenu"
        :style="selector_scene_assembly"
        style="line-height: initial"
      >
        <div class="addmenu-title">
          <span><strong>请选择要添加的组件</strong></span>
          <span class="close" @click="selector_scene_assembly.top = '-400px'"
            ><i class="iconfont icon-guanbi"></i
          ></span>
        </div>
        <div class="assemblymenu" v-if="false">
          <i class="iconfont icon-yonghuming"></i>角色组件
          <span class="only">单个</span>
        </div>
        <div class="assemblymenu" v-if="false">
          <i class="iconfont icon-test-108"></i>旁白组件
          <span class="only">单个</span>
        </div>
        <div class="assemblymenu" @click="pushRes('imgs')">
          <i class="iconfont icon-wodedaoju"></i>图片挂件
          <span class="unonly">多个</span>
        </div>
        <div class="assemblymenu" @click="pushRes('3d')">
          <i class="iconfont icon-wodedaoju"></i>3D组件
          <span class="unonly">多个</span>
        </div>
        <div class="assemblymenu" @click="pushRes('subtitle')">
          <i class="iconfont icon-tianjiazimu"></i>字幕组件
          <span class="only">单个</span>
        </div>
        <div class="assemblymenu" @click="pushRes('commodity')">
          <i class="iconfont icon-shangyong"></i>商品组件
          <span class="only">单个</span>
        </div>
        <div class="assemblymenu" @click="pushRes('voiceover')">
          <i class="iconfont icon-shangyong"></i>旁白组件
          <span class="only">单个</span>
        </div>
      </div>
    </div>
    <!-- '基础设置弹窗' -->
    <TDialog
      top="0"
      :visible.sync="visibleBase"
      width="40%"
      title="基础设置"
      @close="cancel"
    >
      <!-- 使用v-slot指定插槽进行编辑 -->
      <div class="item-row">
        <div class="item-name">场景模板名称:</div>
        <input
          v-model.trim="t9video.videoobj.scenes[0].scenetitle"
          class="input"
          type="text"
          style="width: 50%; margin: 0 0 0 20px"
        />
      </div>
      <div class="item-row">
        <div class="item-name">渲染器窗口宽高:</div>
        <div class="item-value">
          高度:<input
            v-int
            type="number"
            v-model.number="t9video.videoobj.scenes[0].height"
            style="width: 50px"
          />
        </div>
        <div>
          宽度:<input
            v-int
            type="number"
            v-model.number="t9video.videoobj.scenes[0].width"
            style="width: 50px"
          />
        </div>
      </div>
      <div class="item-row">
        <div>场景模板背景:</div>
        <div
          class="item-value"
          style="
            width: 200px;
            height: 150px;
            line-height: 150px;
            text-align: center;
            border-radius: 10px;
            overflow: hidden;
          "
        >
          <div class="scene-box" :style="changjingbg">
            <div class="openScene" @click="selector_box_show = true">
              <span class="img iconfont icon-yuanqu"></span>
              <span>修改场景背景</span>
            </div>
          </div>
        </div>
      </div>
      <div class="item-row" v-if="false">
        <div>场景模板背景声音:</div>
      </div>
      <template v-slot:footer>
        <button
          style="background-color: #78aff9; margin-right: 10px"
          @click="addOrEdit"
        >
          确定
        </button>
        <!-- <button @click="visible = false">取消</button> -->
      </template>
    </TDialog>
    <!-- 背景选择器 -->
    <div class="selector_box" v-if="selector_box_show">
      <div class="selector_box_content">
        <bgSelector @selector="updateBack"></bgSelector>

        <div class="selector_box_close" @click="selector_box_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dataURLtoBlob, localData, asyncLoadJs, getRole, validate, getUserConfig } from '@/components/util/util_fun.js'
import { t9oss } from '@/components/util/util.js'
import { uploadFile } from '@/components/util/alioss.js'
import draggable from 'vuedraggable'
export default {
  name: 'setScene',
  data () {
    return {
      selector_scene_assembly: {
        top: "-400px"
      },// 添加组件
      visibleBase: false,// 基础设置弹窗
      selector_box_show: false,// 背景选择器
      changjingbg: {},
      actionLoading: false,// 
    }
  },
  props: {
    t9video: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    res_index: { //当前选择的元素
      type: Number,
      default: 0
    },
  },
  components: {
    draggable,// 拖拽排序组件
    bgSelector: () => import(/*webpackChunkName:"bgImgSelect"*/'@/views/setup/TabBg.vue'),
  },
  created () {
    if (this.t9video.videoobj.scenes[0].scene.gradient) {
      this.changjingbg = this.t9video.videoobj.scenes[0].scene.gradient
      // console.log('this.changjingbg', this.changjingbg)
    } else if (this.t9video.videoobj.scenes[0].scene.materialPath) {
      this.changjingbg.background = `center/cover url(${this.t9video.videoobj.scenes[0].scene.materialPath})`
      // console.log('this.changjingbg', this.changjingbg)

    } else {
      // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"
      // console.log('this.changjingbg', this.changjingbg)

    };
  },
  methods: {
    goSetRole () {
      // console.log('user', this.user)
      if (this.user.resobj) {
        localData("set", "historyHodel_" + this.$store.state.userinfo.userId, this.user.resobj)
      } else {
        localData("set", "historyHodel_" + this.$store.state.userinfo.userId, this.user)
      }
      this.$router.push('/setrole')
    },
    dragEnd () {
      // console.log('触发拖拽完成dragEnd', this.t9video.videoobj.scenes[0].res)
      console.log('触发拖拽完成dragEndsssssssssssssssssss',)
      this.$emit('setScene')
    },
    // (del)
    addOrEdit () {
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      this.$emit('localDatasave')
      // console.log('保存的id', this.t9video.videoobj.scenes[0].sceneId)
      // return
      if (!this.t9video.videoobj.scenes[0].sceneId || this.t9video.videoobj.scenes[0].sceneId.length == 1) {
        // this.visible = true
        this.saveScene()
      } else {
        this.editScene()
      }
    },
    // (del)
    saveScene () { //保存当前编辑场景
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      this.$emit('localDatasave')
      // 获取当前渲染器的截图
      this.actionLoading = true
      this.$message.warning('保存中...')
      t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/save", { sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(that.t9video.videoobj.scenes[0]), sceneType: 2, sceneCover: url }).then(res => {
            // that.selector(res.data.sceneId)
            that.$emit('selector', res.data.sceneId)
            that.$message.success('保存成功')
            that.actionLoading = false
            that.$emit('close')

          })
        }, function (err) {
          // console.log("封面上传失败！" + err)
          that.actionLoading = false
          that.$emit('close')

          // that.saveCenter();
          return err
        })

      }, 'scene')


    },
    // (del)
    editScene () {
      this.actionLoading = true
      this.$message.warning('保存中...')
      t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          // console.log('url', url)
          // return
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/modfiy", { sceneId: that.t9video.videoobj.scenes[0].sceneId, sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(that.t9video.videoobj.scenes[0]), sceneType: 2, sceneCover: url }).then(res => {
            // console.log('保存场景3', res)
            that.$message.success('修改成功')
            that.actionLoading = false
            // that.cancel()
            that.$emit('close')

          })
        }, function (err) {
          that.$message.error('修改失败')
          // console.log("封面上传失败！" + err)
          that.$emit('close')
          that.actionLoading = false
          // that.saveCenter();
          return err
        })

      }, 'scene')
    },
    upminiback (obj) { //将小窗口的背景展示修改下(del)
      // debugger
      // console.log('选择内容', obj)
      if (obj.type) { //如果是纯色背景
        if (obj.type == 'transparent') {//透明
          // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        else {
          // debugger
          this.changjingbg = obj.gradient
        }
      } else { // 图片背景
        this.changjingbg = {}
        if (obj.color) {
          this.changjingbg.background = ` center/cover url(${obj.color.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        } else if (obj.materialPath) {
          this.changjingbg.background = ` center/cover url(${obj.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        // console.log(obj);
      }
      // console.log('场景对象', this.changjingbg)
    },
    //修改背景色(del)
    updateBack (color) {
      //缓存只能存json
      this.upminiback(this.t9video.videoobj.scenes[0].scene = color)
      this.t9video.videoobj.scenes[0].scene = color
      console.log('修改背景色cccccccccccccccccccc')
      window.t9render.setScene(this.t9video.videoobj.scenes[0])
      // this.localDatasave()
      // var json = { color: color }
      // this.setconfig("bg", json)
      this.selector_box_show = false
    },
    cancel () {
      this.$emit('close')
    },
    changeTab (res, type, index) { // 点击当前场景中的组件触发
      // console.log('当前点击的id类型索引', res, type, index)
      this.$emit('selelement', res, index)
    },
    deleteres (item) { // 移除当前场景中的组件
      this.$emit('removele', item)

      //   this.localDatasave() // 数据持久化
    },
    pushRes (type) { // 往场景中添加组件

      switch (type) {
        case 'subtitle':
          // 判断数组中是否已经有restype=subtitle的数据
          let subtitleI = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype == 'subtitle')
          if (subtitleI == -1) {
            this.t9video.videoobj.scenes[0].res.unshift({
              resid: 'subtitle',
              restype: 'subtitle',
              resobj: { fontsize: 24, fontcolor: '#F4F4F4' },
              resname: '字幕组件',
              startend: [0, 0],
              timeline: []
            })
            window.t9render.setScene(this.t9video.videoobj.scenes[0])
            this.$emit('resAddCallBack')

          } else {
            this.$message.error('已经存在字幕组件')
          }
          break
        case 'imgs':
          //   this.guajiansel = true
          // 添加图片挂件
          this.$emit('addele', type)

          break
        case '3d':
          //  
          // 添加3d组件挂件
          this.$emit('addele', type)
        case 'voiceover':
          //  
          // 添加旁白组件 
          this.$emit('addele', type)

          break

        case 'commodity':
          let commodityI = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype == 3)
          if (commodityI == -1) {
            this.t9video.videoobj.scenes[0].res.unshift({
              resid: "commodity",
              resname: "商品组件",
              resobj: {
                type: "commodity",
                textname: { //名字
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 500,
                  opacity: 1
                },
                textprice: { //价格
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 540,
                  opacity: 1
                },
                textnum: { //编号
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 580,
                  opacity: 1
                },
                textdesc: { //描述，字幕
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 800,
                  opacity: 1
                },
                textimg: { //图片
                  x: 10,
                  y: 20,
                  time: 4,//商品图片切换间隔
                  width: 250,
                  height: 250,
                  opacity: 1
                }
              },
              restype: 3,
              startend: [0, 0], //起止时间，单位秒，0为未设置
              timeline: [
              ]
            })
            window.t9render.setScene(this.t9video.videoobj.scenes[0])
            this.$emit('resAddCallBack')
          } else {
            this.$message.error('已经存在商品组件')
          }

          break
      }


      this.selector_scene_assembly.top = '-400px'
    },
  },

}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
.scene {
  // 场景选择样式
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  height: 20%;
  overflow-y: auto;
  border: 1px solid;
  @include border_color("bordercolor");
  @include background("uibg2");
  @include font_color("fontcolor");
  margin-bottom: 2%;
  .scene-box {
    .scenes-title {
      display: flex;
      justify-content: space-between;
      line-height: 26px;
      padding: 5px 10px;
      font-size: 14px;
      .scenes-title-more {
        :hover {
          cursor: pointer;
          color: #000;
        }
      }
    }
    .scene-title {
      // 场景头部
      // padding: 10px;
      // display: flex;
      // justify-content: space-between;
      // height: 150px;
      // text-align: center;
      // position: relative;
      // overflow: hidden;
      .title {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
      }
      :hover {
        color: #fff;
      }
      .openScene {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
        -webkit-transform: translate(-50%, -50%);
        cursor: pointer;
      }
      .btn {
        cursor: pointer;
      }
    }
    .scene-items {
      overflow-y: auto;
      max-height: 450px;
      margin: 0px 10px;

      .scene-item {
        // 场景列表
        margin-bottom: 5px;
        // background-color: yellowgreen;
        display: flex;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        // margin-right: 5px;

        border-radius: 5px;
        text-align: center;
        flex-shrink: 0;
        cursor: pointer;
        position: relative;

        .img {
          font-size: 24px; // 修改icon大小
          margin-right: 5px;
          width: 40px;
          height: 40px;
          background-position: center;
          background-size: auto 100%;
          background-repeat: no-repeat;
          display: inline-block;
          border-radius: 5px;
        }
      }
      .scene-item.item {
        &:hover {
          background-color: #fff;
          color: #000;
          cursor: move;
        }
      }
      // .item {
      //   :hover {
      //     cursor: move;
      //   }
      // }
    }
  }
  .scene-addmenu {
    // 添加场景
    position: absolute;
    right: 0;
    top: -1000px;
    width: 100%;
    z-index: 999;
    color: #666;
    transition: all 0.3s;
    @include background("uibg");
    .assemblymenu {
      padding: 10px;
      border-bottom: 1px #ddd solid;
      cursor: pointer;
      i {
        font-size: 21px !important;
        margin-right: 10px;
      }

      &:hover {
        background-color: #f5f5f5;
      }
      .only {
        background-color: #ff5a52;
        color: #fff;
        font-size: 12px;
        border-radius: 5px;
        padding: 2px 5px;
        float: right;
      }
      .unonly {
        background-color: #39f;
        color: #fff;
        font-size: 12px;
        border-radius: 5px;
        padding: 2px 5px;
        float: right;
      }
    }

    .addmenu-title {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px #ddd solid;

      .close {
        cursor: pointer;
        font-size: 18px !important;
        margin-right: 10px;
      }
    }
  }
}
.item-row {
  display: flex;
  // line-height: 35px;
  min-height: 35px;
  margin: 10px 0;
  .item-name {
    // margin: 0 auto; /*位置居中*/
  }
  .item-value {
    margin-left: 10px; /*位置居中*/
    .scene-box {
      color: #484848;

      :hover {
        cursor: pointer;
        color: #fff;
      }
    }
  }
}
.input {
  display: block; /*变为块元素*/
  width: 80%; /*设置宽度*/
  margin: 0 auto; /*位置居中*/
  outline: 0; /*点击时去除边框*/
  border: none; /*去除外边框*/
  background-color: #fff; /*设置背景色*/
  padding: 10px 10px; /*设置输入内容的上下边距*/
  border-radius: 4px; /*设置圆角*/
  box-shadow: inset 1px 1px 6px 0 rgba(0, 0, 0, 0.3); /*设置内部阴影*/
  transition: all 250ms; /*鼠标划过时监听所有变化250ms*/
  &:hover {
    background: #f5efef; /*鼠标滑过时背景颜色改变*/
    box-shadow: inset 1px 1px 6px 0 #e8eafc; /*鼠标划过时边框发生改变*/
  }
}
</style>